import { isSmallScreen } from './utils';
const tabs = () => {
    document
        .querySelectorAll('.tab__container-holder')
        .forEach((tabContainerHolder) => {
        const tabContainer = tabContainerHolder.querySelector('.tab__content-container');
        const tabItems = tabContainerHolder.querySelectorAll('.tab__title');
        const allTabContents = tabContainer
            ? tabContainer.querySelectorAll('.tab__content')
            : [];
        const mobileTabContainer = tabContainerHolder.querySelector('#tab__container');
        const mobileContentItems = mobileTabContainer
            ? mobileTabContainer.querySelectorAll('.tab__content')
            : [];
        const setActiveTab = (tabId, forceOpen = false, onInit = false) => {
            tabItems.forEach((item) => {
                item.classList.toggle('tab--active', item.id === tabId && forceOpen);
            });
            const isContentVisible = (content) => content.classList.contains('active') &&
                content.classList.contains(tabId);
            (isSmallScreen() ? mobileContentItems : allTabContents).forEach((content) => {
                if (content.classList.contains(tabId)) {
                    content.classList.add('active');
                    content.style.maxHeight = `${content.scrollHeight + 20}px`;
                    isSmallScreen() && !onInit
                        ? mobileTabContainer.scrollIntoView({ block: 'start' })
                        : null;
                }
                else {
                    content.classList.remove('active');
                    content.style.maxHeight = '';
                }
            });
            if (!forceOpen) {
                const activeContent = Array.from(isSmallScreen() ? mobileContentItems : allTabContents).find(isContentVisible);
                if (activeContent) {
                    activeContent.style.maxHeight = '';
                    setTimeout(() => activeContent.classList.remove('active'), 300); // Adjust timing based on CSS transition
                }
            }
        };
        tabItems.forEach((tabTitle, index) => {
            tabTitle.addEventListener('click', () => {
                const isOpen = tabTitle.classList.contains('tab--active');
                if (isOpen && !isSmallScreen()) {
                    return;
                }
                setActiveTab(tabTitle.id, !isOpen, false);
            });
            if (index === 0) {
                setActiveTab(tabTitle.id, true, true);
            }
            else {
                tabTitle.classList.remove('tab--active');
                allTabContents[index].classList.remove('active');
                allTabContents[index].style.maxHeight = '';
            }
        });
    });
};
function contentTab() {
    const titles = document.querySelectorAll('.map__title');
    const contents = document.querySelectorAll('.map__content');
    const openTab = (title) => {
        titles.forEach((title) => {
            if (title.classList.contains('bg-primary-color')) {
                title.classList.remove('text-white');
                title.classList.remove('bg-primary-color');
                title.classList.add('bg-[#e2f5fc]');
                title.classList.add('text-primary-color');
            }
        });
        title.classList.remove('bg-[#e2f5fc]');
        title.classList.add('bg-primary-color');
        title.classList.remove('text-primary-color');
        title.classList.add('text-white');
        const titleId = title.id;
        contents.forEach((content) => {
            if (!content.classList.contains('hidden')) {
                content.classList.add('hidden');
            }
            if (content.classList.contains(titleId)) {
                content.classList.remove('hidden');
            }
        });
    };
    titles.forEach((title, index) => {
        title.addEventListener('click', () => {
            openTab(title);
        });
        if (index == 0) {
            openTab(title);
        }
    });
}
const productTab = () => {
    const titles = document.querySelectorAll('.product-tab__title');
    const contents = document.querySelectorAll('.product-tab__content');
    const openTab = (title) => {
        titles.forEach((title) => {
            if (title.classList.contains('product-tab__title--active')) {
                title.classList.remove('product-tab__title--active');
            }
        });
        title.classList.add('product-tab__title--active');
        const titleId = title.id;
        contents.forEach((content) => {
            if (content.classList.contains('product-tab__content--active')) {
                content.classList.remove('product-tab__content--active');
            }
            if (content.classList.contains(titleId)) {
                content.classList.add('product-tab__content--active');
            }
        });
    };
    titles.forEach((title, index) => {
        title.addEventListener('click', () => {
            openTab(title);
        });
        if (index == 0) {
            openTab(title);
        }
    });
};
const blogTab = () => {
    const blogTabContainers = document.querySelectorAll('.blog-tab__container');
    const globalTitles = document.querySelectorAll('.blog-tab__title');
    const globalContents = document.querySelectorAll('.blog-tab__content');
    blogTabContainers.forEach((blogTabContainer) => {
        const titles = blogTabContainer.querySelectorAll('.blog-tab__title');
        const openTab = (title) => {
            const isOpen = title.classList.contains('blog-tab__title--active');
            globalTitles.forEach((title) => {
                if (title.classList.contains('blog-tab__title--active')) {
                    title.classList.remove('blog-tab__title--active');
                }
            });
            if (isOpen) {
                globalContents.forEach((content) => {
                    if (content.classList.contains('blog-tab__content--active')) {
                        content.classList.remove('blog-tab__content--active');
                    }
                });
            }
            else {
                title.classList.add('blog-tab__title--active');
                const titleId = title.id;
                globalContents.forEach((content) => {
                    if (content.classList.contains('blog-tab__content--active')) {
                        content.classList.remove('blog-tab__content--active');
                    }
                    if (content.classList.contains(titleId)) {
                        content.classList.add('blog-tab__content--active');
                    }
                });
            }
        };
        titles.forEach((title, index) => {
            title.addEventListener('click', () => {
                openTab(title);
            });
        });
    });
};
export { tabs, contentTab, productTab, blogTab };
